import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid2";
import DialogSearchInsuranceType from "../../../Dialog/Search/DialogSearchInsuranceType";
import TileInsuranceType from "../../../Tile/TileInsuranceType";
import PropTypes from "prop-types";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterOrderActivityInsuranceType extends CardClass {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state.insuranceTypeDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (insuranceTypeId) => {
      const filter = this.props.queue.filter;
      if (!filter["order_activity.insurance_type_id"]?.properties?.value) {
        return;
      }
      filter["order_activity.insurance_type_id"].properties.value = filter[
        "order_activity.insurance_type_id"
      ].properties.value.filter((entry) => entry !== insuranceTypeId);
      if (
        filter["order_activity.insurance_type_id"].properties.value.length === 0
      ) {
        delete filter["order_activity.insurance_type_id"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.["order_activity.insurance_type_id"]?.properties
        ?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.["order_activity.insurance_type_id"]?.properties
        ?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter["order_activity.insurance_type_id"].properties.operator = event
        .target.checked
        ? "not in"
        : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((insuranceTypeId) => {
              return (
                <MUIGrid
                  key={insuranceTypeId}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                  }}
                >
                  <TileInsuranceType
                    insuranceType={
                      this.context.insuranceTypesIndexed[insuranceTypeId]
                    }
                    iconButtons={[
                      <MUIIconButton
                        onClick={() => handleRemove(insuranceTypeId)}
                      >
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState
            line1="Not Configured"
            line2="Showing all Insurance Types"
          />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Insurance Types
   */
  renderDialog() {
    const handleAdd = (insuranceType) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["order_activity.insurance_type_id"]) {
        filter["order_activity.insurance_type_id"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter["order_activity.insurance_type_id"].properties.value = [
        ...new Set([
          ...(filter["order_activity.insurance_type_id"].properties.value ||
            []),
          insuranceType.id,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearchInsuranceType
        open={this.state.insuranceTypeDialogOpen}
        onClose={() => this.setState({ insuranceTypeDialogOpen: false })}
        onSelect={handleAdd}
      />
    );
  }

  /**
   * Renders add Insurance Type button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        insuranceTypeDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Insurance Type
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Order Activity > Primary Insurance > Type";
  }
}
